var _style, _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTl(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill:#FFFFFF;}")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_1_",
    cx: 256,
    cy: 256,
    r: 256
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "mask"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#mask)",
      fill: "#DC241F"
    },
    d: "M1024,512V0H0v512H1024 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#mask)",
      fill: "#FFC726"
    },
    d: "M0,0v512l512-256L0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#mask)",
      fill: "#000000"
    },
    d: "M0,0v512l341.3-256L0,0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(34.268063,-15.2299,15.2299,34.268063,203.69352,-275.38379)",
    style: {
      clipPath: "url(#mask)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-7.9,9.7l-1.3,4.1l3.5-2.5l-4.3,0l3.5,2.5L-7.9,9.7"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTl);
export default __webpack_public_path__ + "static/media/tl.ed8f01a32ab6c1b123fafbdf6643d282.svg";
export { ForwardRef as ReactComponent };